import { Box, Button, Checkbox, CircularProgress, TextField, Typography } from "@mui/material"
import React, { useEffect, useState } from "react"
import { Controller, useForm } from "react-hook-form";
import { useSearchParams } from "react-router-dom";
import { getUpdateUserModel, updateUser } from "../../../../../../api/apiCall";
import { useAuth } from "../../../../../../auth/auth";
import { toast } from "react-toastify";
import ChangePassword from "./Change Password/ChangePassword";
import UserRoles from "./User Roles/UserRoles";
import AccessForbidden from "../../../../../../components/Access/AccessForbidden";
import Loading from "../../../../../../components/Loading/Loading";

type FormValues = {
    id: string
    name: string;
    surname: string;
    pts: string;
    username: string;
    phoneNumber: string;
    notes: string;
    email: string;
    postCode: string;
    location: string;
    verified: any;
    locked: any;
}

const EditUserAccount = () => {
    const {state} = useAuth();
    const [isLoading, setIsLoading] = useState(true);
    const [buttonLoading, setButtonLoading] = useState(false);
    const [searchParams] = useSearchParams();
    const [isAdmin, setIsAdmin] = useState(false);
    const {register, handleSubmit, control, reset} = useForm<FormValues>();

    const getUpdateWorkerData = async () => {
        const response = await getUpdateUserModel(state.user?.token, searchParams.get('userId'));
        if(response?.response?.status === 403) {
            setIsAdmin(true);
            setIsLoading(false);
        } else {
            reset(response);
            setIsLoading(false);
        }
    }

    const handleUpdateWorker = async (data: any) => {
        setButtonLoading(true);
        const response: any = await updateUser(state.user?.token, data);
        if(response?.status === 200) {
            setTimeout(() => {
                setButtonLoading(false);
                toast.success('Updated successfully');
            }, 500);
        } else {
            toast.error('Something went wrong!');
        }
    };

    useEffect(() => {
        getUpdateWorkerData();
    }, [])

    if(isLoading) {
        return <Loading />
    }

    if(isAdmin) {
        return <AccessForbidden />;
    }

    return (
        <>
            <Box sx={{margin: "auto", backgroundColor: "#f2f5fc", padding: 5}}>
                <Box sx={{maxWidth: 650, margin: "auto", backgroundColor: "#fff", padding: 5}}>
                    <Typography variant="h5" fontWeight="bold" gutterBottom>
                        Edit User Account
                    </Typography>
                    <Box sx={{borderBottom: 1, borderColor: "divider", mb: 2}} />

                    {isLoading ? (
                        <Box display="flex" justifyContent="center" mt={5}>
                            <CircularProgress />
                        </Box>
                    ) : (
                        <>
                            <Box display="grid" gridTemplateColumns={{ xs: "1fr" }} gap={3} mt={3}>
                                <TextField label="Name" variant="outlined" fullWidth size="small" {...register("name")} />
                                <TextField label="Surname" variant="outlined" fullWidth size="small" {...register("surname")} />
                                <TextField label="Username" variant="outlined" fullWidth size="small" {...register("username")} disabled />
                                <TextField label="PTS" variant="outlined" fullWidth size="small" {...register("pts")} />
                                <TextField label="Phone Number" variant="outlined" fullWidth size="small" {...register("phoneNumber")} />
                                <TextField label="Email" variant="outlined" fullWidth size="small" {...register("email")} />
                                <TextField label="Post Code" variant="outlined" fullWidth size="small" {...register("postCode")} />
                                <TextField label="Location" variant="outlined" fullWidth size="small" {...register("location")} />
                                <TextField label="Notes" variant="outlined" fullWidth size="small" multiline rows={6} {...register("notes")} />
                            </Box>

                            <Typography fontSize={17}>
                                Verified:
                                <Controller
                                    name="verified"
                                    control={control}
                                    render={({ field }) => <Checkbox {...field} checked={field.value} />}
                                />
                                Locked:
                                <Controller
                                    name="locked"
                                    control={control}
                                    render={({ field }) => <Checkbox {...field} checked={field.value} />}
                                />
                            </Typography>

                            <Box display="flex" justifyContent="center" mt={3}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    type="submit"
                                    style={{boxShadow: "none", backgroundColor: "#156bc2", width: 160}}
                                    disabled={buttonLoading}
                                    onClick={handleSubmit(handleUpdateWorker)}
                                >
                                    {buttonLoading ? (
                                        <CircularProgress size={25} style={{color: 'white'}} />
                                    ) : ('Save')}
                                </Button>
                            </Box>
                        </>
                    )}
                </Box>
                {!isLoading &&
                    <>
                        <Box mt={4}></Box>
                        <UserRoles userId={searchParams.get('userId')} />
                        <Box mt={4}></Box>
                        <ChangePassword userId={searchParams.get('userId')} />
                    </>
                }
            </Box>
        </>
    );
};

export default EditUserAccount;
